module.exports = __webpack_public_path__ + "img/default-bg-tip.15e95f09.png";